import {Subject} from 'rxjs';

export class FetchCountries {
    public static readonly type = '[Countries] FetchCountries';

    constructor(public cancellationToken?: Subject<any>) {
    }
}
